import type { SxProps, Theme } from '@mui/material/styles'

/** Fixed 18×18 red dot — size does not grow for multi-digit labels */
export const notificationBellBadgeSx = {
  position: 'absolute',
  top: -5,
  right: -5,
  width: 18,
  height: 18,
  minWidth: 18,
  boxSizing: 'border-box',
  borderRadius: '999px',
  bgcolor: '#EF4444',
  color: '#fff',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  overflow: 'hidden',
  p: 0,
} as const

export const notificationBellIconWrapSx = {
  position: 'relative',
  display: 'flex',
} as const

/** Light-header bell button — matches Sensemaker AppShell notification wrapper */
export const notificationBellButtonSx = {
  width: 36,
  height: 44,
  borderRadius: '10px',
  color: '#4a5565',
  '&:hover': { bgcolor: 'rgba(0, 0, 0, 0.04)', color: '#111827' },
} as const

export function notificationBellBadgeTextSx(
  display: string | number,
): SxProps<Theme> {
  const compact = String(display).length > 1
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    fontSize: compact ? '10px' : '11px',
    fontWeight: 600,
    lineHeight: 1,
    letterSpacing: compact ? '-0.05em' : '0',
    textAlign: 'center',
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
  }
}
